import { combineReducers } from 'redux';
import { AuditLogTypes } from '../../action_types';
import { handleRequest, initialRequestState } from './helpers';

function getAuditLogsBySuperAdmin(state = initialRequestState(), action) {
  return handleRequest(
    AuditLogTypes.GET_AUDIT_LOGS_BY_SUPERUSER_REQUEST,
    AuditLogTypes.GET_AUDIT_LOGS_BY_SUPERUSER_SUCCESS,
    AuditLogTypes.GET_AUDIT_LOGS_BY_SUPERUSER_FAIL,
    state,
    action
  );
}

function getAuditLogsByOrgAdmin(state = initialRequestState(), action) {
  return handleRequest(
    AuditLogTypes.GET_AUDIT_LOGS_BY_ORG_ADMIN_REQUEST,
    AuditLogTypes.GET_AUDIT_LOGS_BY_ORG_ADMIN_SUCCESS,
    AuditLogTypes.GET_AUDIT_LOGS_BY_ORG_ADMIN_FAIL,
    state,
    action
  );
}


export default combineReducers({
  getAuditLogsBySuperAdmin,
  getAuditLogsByOrgAdmin,
});